//LoyaltyPerPaymentMethodReportViewModel
(function () {
  'use strict';

  angular.module('sempraWebapp').factory('LoyaltyPerPaymentMethodReportViewModel', loyaltyPerPaymentMethodReportViewModelFactory);

  /** @ngInject */
  function loyaltyPerPaymentMethodReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, dispatcher, ActionTypesEnum) {
    function LoyaltyPerPaymentMethodReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'line',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    LoyaltyPerPaymentMethodReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return LoyaltyPerPaymentMethodReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      that.total = 0;
      that.totalByGroupName = [];
      reportActions.getLoyaltyPerPaymentMethodForPeriod(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        successData.total.forEach(function (item, index) {
          that.total += item;

          that.totalByGroupName.push({
            total: item,
            name: successData.groupNames[index]
          });
        });
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();
